import Header from "../components/Header";
import Footer from "../components/Footer";
import ContactForm from "../components/ContactForm";

function Contact() {
    return (
        <div className="page-wrapper">
            <Header />
            <div className="web-body">
            <ContactForm/>
            </div>
            <Footer />
        </div>
    );
}

export default Contact;
